export default __webpack_public_path__ + "static/everywhere-lab-visit-4-5a8953716126d1a4ddf76a032f780d16.jpg";